module.exports = __webpack_public_path__ + "images/emoji_4_color632152f9e8d83c6e98662df18ce7c545.svg";